/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Credentials_Global_Toggle_DescriptionInputs */

const es_components_credentials_global_toggle_description = /** @type {(inputs: Components_Credentials_Global_Toggle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los usuarios del tenant pueden ver y usar esta credencial.`)
};

const en_components_credentials_global_toggle_description = /** @type {(inputs: Components_Credentials_Global_Toggle_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All users in the tenant can view and use this credential.`)
};

/**
* | output |
* | --- |
* | "All users in the tenant can view and use this credential." |
*
* @param {Components_Credentials_Global_Toggle_DescriptionInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_credentials_global_toggle_description = /** @type {((inputs?: Components_Credentials_Global_Toggle_DescriptionInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Credentials_Global_Toggle_DescriptionInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_credentials_global_toggle_description(inputs)
	return en_components_credentials_global_toggle_description(inputs)
});
export { components_credentials_global_toggle_description as "components.credentials.global.toggle_description" }